import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'highlight',
    standalone: false
})

export class HighlightPipe implements PipeTransform {

    transform(value: string, args: any): string {
        if (!args) { return value; }
        // The argument is whatever the user typed into a search box, so anything
        // with regular expression meaning in it (brackets, +, ?) has to be escaped
        // or the expression either throws or matches the wrong thing.
        const pattern = String(args).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        return value.replace(new RegExp(pattern, 'gi'), "<mark>$&</mark>");
    }
}
